import { clearBet } from "../../store/entities/bet-slice";
import { clearCashout } from "../../store/entities/cashout-slice";
import { clearFreeBet } from "../../store/entities/free-bet-slice";
import { setRacoonMove } from "../../store/entities/raccoon-move-slice";
//import { setRaccoonTakeOver } from "../../store/entities/raccoon-take-over";
import { clearTakeStep } from "../../store/entities/take-step-slice";

export const moveRaccoonToDefaultPosition = (dispatch, racoonIndex = -2 ) => {
  dispatch(setRacoonMove({
    position: 0,
    firstClick: true,
    raccoonIndex: -2
  }));
  if (racoonIndex !== -1) {
    dispatch(clearBet());
    dispatch(clearFreeBet());
  }
  
  dispatch(clearCashout());
  dispatch(clearTakeStep());
  //dispatch(setRaccoonTakeOver(false));
} 